import { Injectable } from '@angular/core';
import { Subject, Subscription } from 'rxjs';
import { filter, map } from '../../../node_modules/rxjs/operators';

import { ActionContextMenu, ActionContextMenuEvent, ActionContextMenuEventType } from '../models/action-context-menu.model';

@Injectable({
    providedIn: 'root'
})
export class ActionContextMenuService {
    private readonly actionContextMenu: Subject<ActionContextMenuEvent>;

    constructor(
    ) {
        this.actionContextMenu = new Subject<ActionContextMenuEvent>();
    }

    public closeMenu(actionContextMenu: ActionContextMenu): void {
        this.updateNext(actionContextMenu, ActionContextMenuEventType.Close);
    }

    public openMenu(actionContextMenu: ActionContextMenu): void {
        this.updateNext(actionContextMenu, ActionContextMenuEventType.Open);
    }

    public subscribeToCloseEvents(callback: (e: ActionContextMenu) => void): Subscription {
        return this.actionContextMenu.asObservable().pipe(
            filter(event => event && event.type === ActionContextMenuEventType.Close),
            map(event => ({ id: event.id, itemIndex: event.itemIndex, actions: event.actions, groupInfo: event.groupInfo, mouseEvent: event.mouseEvent, targetElement: event.targetElement }))
        ).subscribe(callback);
    }

    public subscribeToOpenEvents(callback: (e: ActionContextMenu) => void): Subscription {
        return this.actionContextMenu.asObservable().pipe(
            filter(event => event && event.type === ActionContextMenuEventType.Open),
            map(event => ({ id: event.id, itemIndex: event.itemIndex, actions: event.actions, groupInfo: event.groupInfo, mouseEvent: event.mouseEvent, targetElement: event.targetElement }))
        ).subscribe(callback);
    }

    private updateNext(actionContextMenu: ActionContextMenu, type: ActionContextMenuEventType) {
        if (!actionContextMenu) {
            return;
        }
        this.actionContextMenu.next({
            type,
            id: actionContextMenu.id,
            itemIndex: actionContextMenu.itemIndex,
            actions: actionContextMenu.actions,
            groupInfo: actionContextMenu.groupInfo,
            mouseEvent: actionContextMenu.mouseEvent,
            targetElement: actionContextMenu.targetElement
        });
    }
}
